import { render, staticRenderFns } from "./MenuTemplate.vue?vue&type=template&id=7dafc1d8&scoped=true"
import script from "./MenuTemplate.vue?vue&type=script&lang=js"
export * from "./MenuTemplate.vue?vue&type=script&lang=js"
import style0 from "./MenuTemplate.vue?vue&type=style&index=0&id=7dafc1d8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dafc1d8",
  null
  
)

export default component.exports